import { axios } from "../middleware";

export const updateMyLoadAPI = async (loadId: string, data: any) => {
  return axios.patch(`/loads/${loadId}`, { ...data });
};
